module.exports = __webpack_public_path__ + "img/paulo_macedo.8ee51b5e.jpg";